import { ContentEditor } from './ContentEditor';

export * from './ContentEditor';

export default ContentEditor;
